import { expect } from 'chai';
import { isValidValueForProp, formatTimestamp, severities } from '@oracle/oraclejet-preact/UNSAFE_Message';

describe('Test MessageFormattingUtils', () => {
  it('isValidValueForProp', function () {
    // severity prop:
    // valid severities
    severities.forEach(severity => {
      expect(isValidValueForProp(severity, 'severity')).to.be.true;
    });
    // invalid severity
    expect(isValidValueForProp('foo', 'severity')).to.be.false;
    
    // timestamp prop:
    // valid ISO string
    expect(isValidValueForProp(new Date().toISOString(), 'timestamp')).to.be.true;
    // invalid ISO string
    expect(isValidValueForProp('foo', 'timestamp')).to.be.false;

    // string prop:
    // valid string
    expect(isValidValueForProp('foo', 'string')).to.be.true;
    // invalid strings
    expect(isValidValueForProp('', 'string')).to.be.false;
    expect(isValidValueForProp(null, 'string')).to.be.false;
    expect(isValidValueForProp(undefined, 'string')).to.be.false;
  });

  it('formatTimestamp', function () {
    const validTimestamp = formatTimestamp(new Date().toISOString());
    expect(isValidValueForProp(validTimestamp, 'string')).to.be.true;

    // formatting an invalid timestamp should throw an error, but if not, verify that it's
    // not a valid string prop
    try {
      const invalidTimestamp = formatTimestamp('foo');
      expect(isValidValueForProp(invalidTimestamp, 'timestamp')).to.be.false;
    } catch (e) {
      expect(e).not.null;
    }
  });
});
